import { createAction, props } from '@ngrx/store';
import { TermPayment } from './report.model';

// fetch all
export const fetchTermPaymentRecords = createAction(
    '[Data] fetch term payments records'
);

export const fetchTermPaymentRecordsSuccess = createAction(
    '[Data] fetch term payments records success', 
    props<{ termPaymentData: TermPayment[], termPaymentsTotal: number }>()
);

export const fetchTermPaymentRecordsFail = createAction(
    '[Data] fetch term payments records failure', 
    props<{ termPaymentError: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state report',
);